import type { ElementTransformer, TextMatchTransformer } from "@lexical/markdown"

import { $createMathNode, $isMathNode, MathNode } from "../nodes/math"

// Block math: $$...$$  (on its own line)
export const MathBlockTransformer: ElementTransformer = {
  type: "element",
  dependencies: [MathNode],
  regExp: /^\$\$([\s\S]+?)\$\$$/,
  replace: (parentNode, _children, match) => {
    const latex = match[1].trim()
    if (latex) {
      const mathNode = $createMathNode(latex, true)
      parentNode.replace(mathNode)
    }
  },
  export: (node) => {
    if (!$isMathNode(node) || !node.__displayMode) {
      return null
    }
    return `$$${node.__latex}$$`
  },
}

// Inline math: $...$ (not inside $$...$$)
// Requires either a LaTeX-specific character (\, ^, _) or a single letter
// to avoid matching plain dollar amounts like "$100 and $200".
const INLINE_MATH_REGEX = /(?<!\$)\$([^$\n]*(?:\\|\^|_)[^$\n]*|[a-zA-Z])\$(?!\$)/

export const MathInlineTransformer: TextMatchTransformer = {
  type: "text-match",
  dependencies: [MathNode],
  regExp: INLINE_MATH_REGEX,
  importRegExp: INLINE_MATH_REGEX,
  replace: (textNode, match) => {
    const latex = match[1].trim()
    if (latex) {
      const mathNode = $createMathNode(latex, false)
      textNode.replace(mathNode)
    }
  },
  trigger: "$",
  export: (node) => {
    if (!$isMathNode(node) || node.__displayMode) {
      return null
    }
    return `$${node.__latex}$`
  },
}
